import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { DOM } from "@siteimprove/alfa-aria";
import { Element, Namespace, Node, Query } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Criterion } from "@siteimprove/alfa-wcag";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { hasExplicitRole, hasNonEmptyAccessibleName, isIncludedInTheAccessibilityTree, } = DOM;
const { hasNamespace } = Element;
const { and } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r43",
    requirements: [Criterion.of("1.1.1")],
    tags: [Scope.Component, Stability.Stable],
    evaluate({ document, device }) {
        return {
            applicability() {
                return getElementDescendants(document, Node.fullTree).filter(and(hasNamespace(Namespace.SVG), hasExplicitRole("img", "graphics-document", "graphics-symbol"), isIncludedInTheAccessibilityTree(device)));
            },
            expectations(target) {
                return {
                    1: expectation(hasNonEmptyAccessibleName(device)(target), () => Outcomes.HasName(target.name), () => Outcomes.HasNoName(target.name)),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.HasName = (target) => Ok.of(Diagnostic.of(`The \`<${target}>\` element has an accessible name`));
    Outcomes.HasNoName = (target) => Err.of(Diagnostic.of(`The \`<${target}>\` element does not have an accessible name`));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map